module.exports = __webpack_public_path__ + "whatsapp-share-d7b3b81402c9d6e4d4b4.svg";